<adapt-dialog [fitHeight]="true"
              [padding]="false"
              [width]="480"
              maxHeight="80vh"
              [modal]="false"
              [allowResize]="true"
              [customPosition]="position"
              [closeOnPageNavigation]="false"
              [showCancelButtonOnTitle]="true"
              [hideFooter]="true">
    <h2 adapt-dialog-title
        class="d-print-none d-flex gap-2 align-items-center w-100 me-n2">
        <i class="fas fa-fw fa-stars"></i>
        <span>Lumia Assistant</span>

        @if (chatUiService.hasChatAiSidebarTab) {
            <button class="ms-auto btn btn-blank btn-sidebar"
                    adaptButtonIcon="fal fa-chevron-left"
                    adaptTooltip="Move to sidebar"
                    data-test="move-to-sidebar-button"
                    (click)="moveToSidebar()"></button>
        }
    </h2>

    <div adapt-dialog-content
         class="d-flex flex-column dialog-content p-2 pt-0">
        <adapt-chat-ai [showCost]="true"></adapt-chat-ai>
    </div>
</adapt-dialog>
